export const validation = (formData, setValidationForm) => {
  let isError = []
  // eslint-disable-next-line
  Object.keys(formData).map((el) => {
    const val = formData[el]
    const isEmpty = val === null || val === undefined || val === '' || (Array.isArray(val) && val.length === 0)
    if (isEmpty && el) {
      setValidationForm((old) => ({
        ...old,
        [el]: {
          isError: true,
          message: 'This form is required'
        }
      }))
      isError.push(el)
    }
  })
  return isError.length > 0 ? true : false
}